import { render, staticRenderFns } from "./CreateUsername.vue?vue&type=template&id=7cc8a3fc&scoped=true&"
import script from "./CreateUsername.vue?vue&type=script&lang=ts&"
export * from "./CreateUsername.vue?vue&type=script&lang=ts&"
import style0 from "./CreateUsername.vue?vue&type=style&index=0&id=7cc8a3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc8a3fc",
  null
  
)

export default component.exports